import type { ExploreContentItemContentOneOfMediaLinksItemProjectInfoEngagementAllOf } from './exploreContentItemContentOneOfMediaLinksItemProjectInfoEngagementAllOf';
import type { ExploreContentItemContentOneOfMediaLinksItemProjectInfoEngagementAllOfTwo } from './exploreContentItemContentOneOfMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type ExploreContentItemContentOneOfMediaLinksItemProjectInfoEngagement = ExploreContentItemContentOneOfMediaLinksItemProjectInfoEngagementAllOf & ExploreContentItemContentOneOfMediaLinksItemProjectInfoEngagementAllOfTwo;
